import { DataService } from 'src/app/services/data.service';
import { Component, Output, Input, OnChanges, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { FileSystemFileEntry, UploadEvent } from 'ngx-file-drop';
import { readAndCompressImage } from 'browser-image-resizer';

import * as _ from 'lodash';
import * as uuid from 'uuid/v1';

@Component({
  selector: 'app-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.scss']
})
export class FileUploadComponent implements OnChanges {

  @Output() onFinish = new EventEmitter();
  @Input('file') filePath: string;
  @Input('base64') base64: boolean;

  @ViewChild('uploadImage') uploadImage: ElementRef;

  uploader: any;
  file: string;

  constructor(
    private dataService: DataService
    ) { }

  ngOnChanges() {
    this.file = this.filePath;
  }

  public dropped(event: UploadEvent) {
    for (const droppedFile of event.files) {

      if (droppedFile.fileEntry.isFile) {
        const fileEntry = droppedFile.fileEntry as FileSystemFileEntry;
        fileEntry.file(async (file: File) => {
          if(_.startsWith(file.type, 'image')){

            const config = {
              quality: 1,
              width: 150,
              height: 150
            };

            const fileData = await readAndCompressImage(file, config);
            const base64 = await new Promise((resolve, reject) => {
              const reader = new FileReader();
              reader.readAsDataURL(fileData);
              reader.onloadend = () => {
                resolve(reader.result);
              }
              reader.onerror = (e) => {
                reject(e);
              }
            })

            let key = uuid();

            key = `${key}.${_.last(_.split(file.name, '.'))}`;

            const res = await this.dataService.presignS3File(key, file.type).toPromise();

            if(!res || !res.url){
              throw Error('Something went wrong.');
            }

            this.dataService.uploadS3File(res.url, file).subscribe((res) => {
              this.onFinish.emit(`https://bilinstudio-assets.s3.us-east-2.amazonaws.com/${key}`);
            })
          }
        });
      }
    }
  }

  public delete(){
    this.file = undefined;

    this.onFinish.emit('');
  }
}
